module.exports = __webpack_public_path__ + "images/fa-lp-sl-m-peter-lipovyanov-mobile.webp";